import React, { useState } from 'react';
import PortfolioCompanyList from './PortfolioCompanyList';
import PortfolioCompanyDetail from './PortfolioCompanyDetail';

export default function PortfolioExplorer({ onOpenClient }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [companyId, setCompanyId] = useState(null);

  return (
    <div className="flex gap-4 h-[70vh] p-2">
      <div className="w-72 shrink-0 border border-gray-200 dark:border-gray-700 rounded-lg p-2">
        <PortfolioCompanyList year={year} selectedId={companyId} onSelect={setCompanyId} />
      </div>
      <div className="flex-1 border border-gray-200 dark:border-gray-700 rounded-lg p-3 overflow-hidden">
        <PortfolioCompanyDetail companyId={companyId} year={year} onYearChange={setYear} onOpenClient={onOpenClient} />
      </div>
    </div>
  );
}
